export default {
      id: "CO2-usage",
      viewBox: "0 0 48 44",
      url: __webpack_public_path__ + "img/icons.svg#CO2",
      toString: function () {
        return this.url;
      }
    }